// Local device preferences. Currently just the sound toggle — kept in
// localStorage and mirrored onto the shared `sound` instance so every game
// honours it. Imported once from main.ts so the stored value is applied at
// startup.

import { sound } from "./sound";

const SOUND_KEY = "su_sound";

function read(): boolean {
  try {
    return localStorage.getItem(SOUND_KEY) !== "0";
  } catch {
    return true;
  }
}

let enabled = read();
sound.muted = !enabled;

export function soundEnabled(): boolean {
  return enabled;
}

export function setSoundEnabled(v: boolean): void {
  enabled = v;
  sound.muted = !v;
  try {
    localStorage.setItem(SOUND_KEY, v ? "1" : "0");
  } catch {
    /* private mode */
  }
}
